// Payment gateway: Cashfree Checkout (kept under the old helper names so all pay flows stay unchanged).
export function loadRazorpay() {
    return new Promise((resolve) => {
        if (window.Cashfree) return resolve(true);
        const s = document.createElement("script");
        s.src = "https://sdk.cashfree.com/js/v3/cashfree.js";
        s.onload = () => resolve(true);
        s.onerror = () => resolve(false);
        document.body.appendChild(s);
    });
}

// Opens Cashfree checkout as a modal; onSuccess receives the ids the backend verifies against Cashfree.
export function openRazorpay(order, { onSuccess, onDismiss, onError }) {
    const cf = window.Cashfree({ mode: order.cf_mode || "sandbox" });
    cf.checkout({ paymentSessionId: order.payment_session_id, redirectTarget: "_modal" }).then((res) => {
        const ids = { razorpay_order_id: order.order_id, razorpay_payment_id: order.order_id, razorpay_signature: "cashfree" };
        if (res?.paymentDetails) return onSuccess?.(ids);
        if (res?.error) {
            const msg = String(res.error.message || "").toLowerCase();
            return msg.includes("closed") || msg.includes("cancel") ? onDismiss?.() : onError?.();
        }
        // Modal closed without a clear result — let the backend decide.
        onSuccess?.(ids);
    });
}
